import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { reverse } from 'routes'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import Select from 'components/Select'
import Button from 'components/Button'

import { statusChanged } from 'components/RequestStatus/actions'

import { CLIENTS_URL, CLIENT_VEHICLES_URL, CLAIM_TYPES, CLAIM_DATA_URL } from 'constants'

import './style.scss'

export class ClaimModal extends BaseComponent {

  constructor() {
    super()

    this.state = {
      client: null,
      vehicle: null,
      claimType: null
    }

    this._bind(
      '_fetchClients', '_onVehicleChange', '_onClaimChange',
      '_onClientChange', '_fetchVehicles', '_handleSubmit'
    )
  }

  componentDidMount() {
    this._fetchClients()
  }

  _fetchClients(searchTerm) {
    const querystring = !!searchTerm ? `?q=${searchTerm}` : ''
    return request(`${CLIENTS_URL}${querystring}`)
      .then((res) => {
        const options = res.clients.map((item) => ( { value: item.user.uuid, label: `${item.user.first_name} ${item.user.last_name}` }))
        return { options }
      })
      .catch(console.log)
  }

  _onClientChange(client) {
    this.setState({ client })
  }

  _fetchVehicles(searchTerm) {
    const querystring = !!searchTerm ? `?q=${searchTerm}` : ''
    return request(`${CLIENT_VEHICLES_URL(this.state.client.value)}${querystring}`)
      .then((res) => {
        var options = res.vehicles.map((item) => ( 
          { 
            value: item.id,
            label: (item.maker + ' ' + item.brand + ' - Póliza: ' + item.policy_number + (item.alias ? ' - Alias: ' + item.alias : ''))  
          }
        ))
        options.unshift({ value: '', label: 'Filtra por modelo, alias, póliza o número de placa', disabled: true })
        return { options }
      })
      .catch(console.log)
  }

  _onVehicleChange(vehicle) {
    this.setState({ vehicle })
  }

  _fetchClaimTypes() {
    return request(CLAIM_TYPES)
      .then((res) => {
        const options = res.types.map((item) => ( { value: item.id, label: item.name }))
        return { options }
      })
      .catch(console.log)
  }

  _onClaimChange(claimType) {
    this.setState({ claimType })
  }

  _handleSubmit(e) {
    e.preventDefault()
    this.props.updateRequestStatus('progress', 'Cambio de datos en progreso')
    request(CLAIM_DATA_URL(this.state.vehicle.value), {
      method: 'POST',
      body: {
        type: this.state.claimType.value,
        is_active: true
      }
    }).then((res) => {
      this.props.updateRequestStatus(res.status, res.message)
      const navigateTo = reverse('clients:detail:claim', {
        id: res.claim.client.user.uuid,
        vehicleId: res.claim.vehicle.id
      })
      this.context.toggleModal(false)
      this.context.router.history.push(navigateTo)
    }).catch((err) => {this.props.updateRequestStatus('error', 'Este vehículo ya tiene un siniestro activo')})

  }

  render() {
    const disabled = !!this.state.client && !!this.state.vehicle && !!this.state.claimType
    return (
      <div id="ClaimModal" className="ClaimModal Modal__content">
        <div className="SinisterModal__header d-flex justify-content-between align-items-center">
          <h1>Crear siniestro</h1>
          <span className="material-icons close-button" onClick={() => this.context.toggleModal(false)}>clear</span>
        </div>
        <p className="message">Ingresa los datos necesarios para comenzar un nuevo siniestro</p>
        <form onSubmit={this._handleSubmit} className="f-flex SinisterModal__form">
          <Select
            className="Select-client"
            cache={false}
            label="Cliente"
            loadingPlaceholder="Buscando..."
            loadOptions={this._fetchClients}
            onChange={(selectedOption) => this._onClientChange(selectedOption)}
            placeholder="Busca a tu cliente"
            value={this.state.client}
           />
           {
             this.state.client ? (
               <Select
                 className="Select-vehicle"
                 cache={false}
                 label="Vehículo"
                 loadingPlaceholder="Buscando..."
                 loadOptions={this._fetchVehicles}
                 onChange={(selectedOption) => this._onVehicleChange( selectedOption)}
                 placeholder=""
                 value={this.state.vehicle}
                />
             ) : null
           }

          <Select
            className="Select-type"
            cache={false}
            label="Tipo de siniestro"
            loadingPlaceholder="Buscando..."
            loadOptions={this._fetchClaimTypes}
            onChange={(selectedOption) => this._onClaimChange( selectedOption)}
            placeholder="Selecciona el tipo de siniestro"
            value={this.state.claimType}
           />

          <div className="controls">
            <div className="controls d-flex justify-content-center">
              <Button className="button"
                      size="big"
                      buttonType="primary"
                      disabled={!disabled}>Iniciar siniestro</Button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(null, mapDispatchToProps)(ClaimModal)

ClaimModal.contextTypes = {
  toggleModal: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/modals/ClaimModal/index.js